import useAuthStore from '@/stores/useAuthStore'
import { useMemo } from 'react'
import DraggableLayout from '../shared/DraggableLayout'
import type { WidgetConfig } from '../shared/types'

// Import shared components
import Paper from '@/components/Paper'
import Business from '@/modules/Dashboard/components/shared/Business'
import Events from '../../shared/Events'
import Notifications from '../../shared/Notifications'
import QuoteOfTheDay from '../../shared/QuoteOfTheDay'
import TargetRevenue from '../../shared/TargetRevenue'

// Import HR specific widgets
import WorkDays from '../../shared/WorkDays'
import InterviewScheduleWidget from './widgets/InterviewScheduleWidget'
import LateEmployeesWidget from './widgets/LateEmployeesWidget'
import MyWorkdays from '../../shared/MyWorkdays'
import InternalInformation from '../../shared/InternalInformation'

const HRDashboard = () => {
    const employee = useAuthStore((state) => state.employee)

    // Storage key unique per employee
    const storageKey = useMemo(
        () => `dashboard_layout_hr_${employee?.employee_id || 'default'}`,
        [employee?.employee_id]
    )

    // Widget configurations with colSpan (3, 4, 6, 8, or 12)
    // Row 1: HR Core Tasks - Late Employees + Interview Schedule
    // Row 2: Personal/Team Activities - My Workdays + Events + Business
    // Row 3: Info Widgets - Notifications + Saturday Work Schedule
    const widgets: WidgetConfig[] = useMemo(
        () => [
            {
                id: 'quote_of_the_day',
                component: (
                    <Paper className="h-full">
                        <QuoteOfTheDay />
                    </Paper>
                ),
                colSpan: 12,
            },
            // Row 1: HR Core Tasks
            {
                id: 'my_workdays',
                component: (
                    <Paper className="h-full">
                        <MyWorkdays />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'late_employees',
                component: (
                    <Paper className="h-full">
                        <LateEmployeesWidget />
                    </Paper>
                ),
                colSpan: 3,
            },

            {
                id: 'workday',
                component: (
                    <Paper className="h-full">
                        <WorkDays showCreateButton />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'interview_schedule',
                component: (
                    <Paper className="h-full">
                        <InterviewScheduleWidget />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'notification',
                component: (
                    <Paper className="h-full">
                        <Notifications />
                    </Paper>
                ),
                colSpan: 6,
            },

            {
                id: 'business',
                component: (
                    <Paper className="h-full">
                        <Business />
                    </Paper>
                ),
                colSpan: 3,
            },
            // Row 2: Personal/Team Activities

            {
                id: 'events',
                component: (
                    <Paper className="h-full">
                        <Events />
                    </Paper>
                ),
                colSpan: 3,
            },
            {
                id: 'revenue',
                component: (
                    <Paper className="h-full">
                        <TargetRevenue />
                    </Paper>
                ),
                colSpan: 6,
            },
            {
                id: 'internal-information',
                component: (
                    <Paper className="h-full">
                        <InternalInformation />
                    </Paper>
                ),
                colSpan: 9,
            },
        ],
        []
    )

    return (
        <DraggableLayout
            widgets={widgets}
            storageKey={storageKey}
            department="HUMAN RESOURCE"
        />
    )
}

export default HRDashboard
